import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, CircularProgress, Chip } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import SimpleAdd from 'src/components/SimpleAdd';
import * as actions from '../../../../reducers/form';
import { loadFileAPI } from '../../../../reducers/materialLoad';
import { enqueueSnackbar } from '../../../../reducers/notifier'
import { getWorker } from '../../../../api/project-worker'
import { addUseTool } from "../../../../api/doc";
import { getInventory } from '../../../../api/inventory'
import { delFile, addFile } from '../../../../api/list'
import { fetchDispath } from '../../../../functions/fetch'

const formName = 'AddUserTool'
const columnArr = (idProject) => ([
  {
    bp: { md: 8 },
    field: 'idWorker', label: 'Работник', type: 'autoLoad',
    textProps: {
      path: getWorker.path({ id: idProject }),
      meta: {
        field: 'worker',
        value: 'id',
        labelFunc: (obj) => obj.surname + ' ' + obj.name + ' ' + obj.patronymic
      }
    },
    validator: [value => !!value], errorText: 'Поле обязательно'
  },
  {
    xs: 12, bp: { md: 8 },
    field: 'idInventory', label: 'Оборудование', type: 'autoLoad',
    textProps: {
      path: `${getInventory.path}?free=1&idProject=${idProject}`,
      meta: {
        field: 'tool',
        value: 'inventoryNumber',
        labelFunc: (obj) => obj.inventoryNumber.toString().padStart(5, '0') + ' ' + obj.name
      }
    },
    validator: [value => !!value], errorText: 'Поле обязательно'
  },
  {
    xs: 12, bp: { md: 8 },
    field: 'note',
    label: 'Примечание', type: 'text',
  },
])
export default function AddUseTool({ match, history }) {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(actions.formInitialize({
      idWorker: null,
      idInventory: null,
      note: '',
      fById: {},
      fAllIds: [],
      errorValidate: { idWorker: false, idInventory: false, }
    }, { name: formName }))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
    }
  }, [dispatch])
  const form = useSelector(state => state.form[formName] || state.form.default)
  const handleSave = () => {
    const { idInventory, idWorker, note, fById } = form.values
    let err = false
    const errMsg = (msg) => dispatch(enqueueSnackbar({ message: msg, options: { variant: 'error' } }));
    if (!idInventory) {
      errMsg('Поле оборудование не заполнено')
      err = true
    }
    if (!idWorker) {
      errMsg('Поле работник не заполнено')
      err = true
    }
    if (err) return;
    dispatch(actions.formSubmitAPI({
      props: {
        idWorker: idWorker,
        idInventory: idInventory,
        note: note || '',
        files: Object.values(fById).map(e => e.id),
      },
      url: addUseTool.path({ id: match.params.idProject }),
      method: addUseTool.type,
      history: history
    }, formName))
  }
  return <div className='App-paper'>
    <SimpleAdd
      formName={formName}
      title='Выдать оборудование работнику'
      arr={columnArr(match.params.idProject)}
      gridProps={{ xs: 12, }}
    >
      <LoadButton formName={formName} />
    </SimpleAdd>
    <TableFile formName={formName} />
    <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
    <Button type="submit" color="primary" onClick={handleSave}>Сохранить</Button>
  </div>
}

function LoadButton({ formName }) {
  const dispatch = useDispatch()
  const [loadingFile, setLoadingFile] = useState(false)
  const _handleImageChange = (e) => {
    e.preventDefault();
    if (typeof e.target.files[0] === 'undefined' || e.target.files[0].length === 0) return
    setLoadingFile(true)
    let fileName = e.target.files[0].name
    const fileType = e.target.files[0].type
    dispatch(loadFileAPI({ file: e.target.files[0], path: addFile.path }))
      .then(res => {
        if (res.success) {
          dispatch(actions.formObjAdd({ id: res.id, name: fileName, type: fileType }, {
            field: 'fById',
            id: 'id' + res.id,
            name: formName
          }))
          dispatch(actions.formArrayAdd('id' + res.id, { field: 'fAllIds', name: formName }))
        }
        setLoadingFile(false)
      })
      .catch()
  }
  return <Button disabled={loadingFile} component="label" color='primary'>
    {loadingFile && <CircularProgress size={25} />}
    <span>Прикрепить файл</span>
    <input
      type="file"
      style={{ display: "none" }}
      onChange={(e) => _handleImageChange(e)}
    />
  </Button>
}

function TableFile({ formName }) {
  const fById = useSelector(state => state.form[formName]?.values?.fById || {})
  const fAllIds = useSelector(state => state.form[formName]?.values?.fAllIds || [])
  return <div>
    {fAllIds.map(key => <OneChip key={key} row={key} obj={fById[key]} formName={formName} />)}
  </div>
}

function OneChip({ row, obj, formName }) {
  const dispatch = useDispatch()
  const [deleted, setDeleted] = useState(false)
  const handleDelete = () => {
    setDeleted(true)
    dispatch(fetchDispath({
      param: {
        id: obj.id,
      },
      progress: false,
      request: delFile,
      buff: true
    }))
      .then(res => {
        setDeleted(false)
        if (!res) return;
        dispatch(actions.formArrayDelete(row, { field: 'fAllIds', name: formName }));
        dispatch(actions.formObjDelete({ id: row, field: 'fById', name: formName }));
      })
  }
  return <Chip
    disabled={deleted}
    key={row}
    icon={<DescriptionIcon />}
    label={obj.name}
    onDelete={() => handleDelete()}
  />
}